export enum MarketStatisticStatus {
  NOT_PROCESSED = 'not_processed',
  INTERPOLATED = 'interpolated',
  PROCESSING = 'processing',
  PROCESSED = 'processed',
  PUBLISHED = 'published',
  IN_QUEUE = 'in_queue',
}
